import { COUNTRIES } from '../config';

export const getCountryCode = (country: string) => {
  return COUNTRIES.find((countryInfo) => countryInfo.country === country)?.countryCode;
};
